import React from "react";
import AddDeductTaxRow from "./AddDeductTaxRow";

/**
 * A single Additions/Deductions row.
 * Thin memoized wrapper around the shared AddDeductTaxRow component.
 *
 * Props (3 grouped objects):
 *   rowData  — { row, index, isRemoving, touchedRow, errorRow }
 *   ctx      — { showItemColumn, isReadOnly, formValuesDepartment, formValuesJob,
 *                mappedToOptionsMap, mappedToLookup, accountOptionsMap, accountOptions }
 *   handlers — { setFieldValue, enqueueSnackbar, fetchCoaDetails, onAddNewMappedItem,
 *                remove, setRemovingIndex, showDeleteConfirm, setOpenAddCOA, setPendingCOAField }
 */
const AddDedRow = React.memo(function AddDedRow(props) {
    const isGrouped = Boolean(props.rowData);
    const ctx = isGrouped ? { ...props.ctx, isTax: false } : undefined;

    return isGrouped ? (
        <AddDeductTaxRow rowData={props.rowData} ctx={ctx} handlers={props.handlers} />
    ) : (
        <AddDeductTaxRow {...props} isTax={false} />
    );
});

export default AddDedRow;
